import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PopupWinterSaleComponent } from './popup-winter-sale.component';
import { SubmitedModalModule } from '../../shared/submited-modal/submited-modal.module';
import { RecaptchaWidgetModule } from '../../shared/recaptcha/recaptcha.module';

@NgModule({
  declarations: [PopupWinterSaleComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SubmitedModalModule,
    RecaptchaWidgetModule,
  ],
  exports: [PopupWinterSaleComponent],
})
export class PopupWinterSaleModule {}
